var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepairApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7877 10.8626C19.2752 11.3501 20.0627 11.3501 20.5502 10.8626L21.4377 9.97505L24.0877 12.6251C25.5502 11.1626 25.5502 8.78755 24.0877 7.32505L20.5502 3.78755C20.0627 3.30005 19.2752 3.30005 18.7877 3.78755L17.9002 4.67505V1.50005C17.9002 0.725054 16.9502 0.312554 16.3877 0.875054L13.2127 4.05005C12.6502 4.61255 13.0627 5.56255 13.8377 5.56255H17.0127L16.1252 6.45005C15.6377 6.93755 15.6377 7.72505 16.1252 8.21255L16.5627 8.65005L12.9502 12.2626L7.8127 7.10005V5.85005C7.8127 5.51255 7.6752 5.20005 7.4502 4.96255L4.9252 2.42505C4.4377 1.93755 3.6502 1.93755 3.1627 2.42505L1.3877 4.20005C0.900195 4.68755 0.900195 5.47505 1.3877 5.96255L3.9127 8.50005C4.1502 8.73755 4.4627 8.86255 4.8002 8.86255H6.0502L11.2127 14.0251L10.1502 15.0876H8.5252C7.8627 15.0876 7.2252 15.3501 6.7627 15.8251L0.862695 21.7251C0.375195 22.2126 0.375195 23.0001 0.862695 23.4876L3.5127 26.1376C4.0002 26.6251 4.7877 26.6251 5.2752 26.1376L11.1752 20.2376C11.6502 19.7626 11.9127 19.1376 11.9127 18.4751V16.8626L18.3502 10.4251L18.7877 10.8626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairApplication);
export default __webpack_public_path__ + "static/media/repair_application.be527b72fa4c18c09c76ea8fcc64015c.svg";
export { ForwardRef as ReactComponent };